import Pubnub from 'pubnub';
import BigNumber from 'bignumber.js';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { MessageType } from '../../types';
import { getErrorText } from '../helpers';

type Params = Omit<Pubnub.DeleteMessagesParameters, 'start' | 'end'> & {
  messageType?: MessageType;
  timeToken: string;
  onDelete?: () => void;
};
type Response = { messageType: MessageType };

/**
 * we use this method to delete all types of messages
 * in the all channels
 */
export const deleteMessage = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/deleteMessage',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;
      const { messageType = MessageType.RAISE_HAND, channel, timeToken } = data;
      const endTimeBI = new BigNumber(timeToken);
      const startTimeBI = endTimeBI.plus(new BigNumber(1));
      const start = startTimeBI.valueOf();
      const end = timeToken;

      if (pubnubReducer.pubnub) {
        pubnubReducer.pubnub.addMessageAction({
          channel: channel,
          messageTimetoken: timeToken,
          action: {
            type: 'deleted',
            value: '.',
          },
        });

        await pubnubReducer.pubnub.deleteMessages({
          channel,
          start,
          end,
        });

        data.onDelete?.();

        return { messageType };
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
